import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

export default function swiperBlockSliderCustom() {
    if (typeof Swiper === "undefined") return;

    const sliders = document.querySelectorAll('.block-slider-custom');
    if (!sliders.length) return;

    sliders.forEach((slider) => {
        if (slider.classList.contains('swiper-initialized')) return;

        const swiperEl = slider.querySelector('.block-slider-custom__swiper');
        if (!swiperEl) return;

        const showNav = slider.dataset.showNav === 'true';
        const showPagination = slider.dataset.showPagination === 'true';
        const autoplay = slider.dataset.autoplay === 'true';
        const spaceBetween = parseInt(slider.dataset.spaceBetween) || 30;

        const nextEl = slider.querySelector('.block-slider-custom__next');
        const prevEl = slider.querySelector('.block-slider-custom__prev');
        const pagination = slider.querySelector('.block-slider-custom__pagination');

        const modules = [Pagination];
        if (showNav) modules.push(Navigation);
        if (autoplay) modules.push(Autoplay);

        const options = {
            modules,
            slidesPerView: 1,
            spaceBetween,
            speed: 1200,
        };

        if (showNav && nextEl && prevEl) {
            options.navigation = { nextEl, prevEl };
        }

        if (showPagination && pagination) {
            options.pagination = {
                el: pagination,
                type: 'custom',
                renderCustom: (swiper, current, total) => {
                    return `<span class="block-slider-custom__pagination-counter">${current} / ${total}</span>`;
                },
            };
        }

        if (autoplay) {
            options.autoplay = {
                delay: 5000,
                disableOnInteraction: false,
            };
        }
        try {
            setTimeout(() => {
                const swiper = new Swiper(swiperEl, options);
                // Recalculate layout after Swiper init
                if (swiper && swiper.update) {
                    swiper.update();
                }

                // Enable scroll-to-slide navigation
                enableScrollNavigation(swiper, slider);
            }, 100);
        } catch (err) {
            console.warn('Block Slider Custom init error', err);
        }
    });
}

function enableScrollNavigation(swiper, sliderContainer) {
    let scrollLocked = false;
    let scrollCounter = 0;
    let releaseCounter = 0;
    let aligned = false;           // whether page is snapped to slider top
    let pinnedScrollY = 0;        // Store the pinned scroll position
    const scrollsNeeded = 4;      // Scrolls needed to change slide
    const releaseNeeded = 2;      // Extra scrolls at boundary to release page scroll

    // Detect if slider is in viewport
    function isInViewport() {
        const rect = sliderContainer.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    }

    // Listen for scroll and restore pinned position when scroll is locked
    function handleScroll() {
        if (scrollLocked && pinnedScrollY !== undefined) {
            // Compensate scroll offset to keep page pinned
            const currentScroll = window.scrollY;
            if (currentScroll !== pinnedScrollY) {
                // Prevent smooth scroll from executing; instant jump back
                document.documentElement.scrollTop = pinnedScrollY;
                document.body.scrollTop = pinnedScrollY;
                window.scroll(0, pinnedScrollY);
            }
        }
    }

    // Lock/unlock page scroll
    function lockScroll() {
        if (!scrollLocked) {
            document.body.style.overflow = 'hidden';
            // Disable smooth scroll during lock
            document.documentElement.style.scrollBehavior = 'auto';
            document.body.style.scrollBehavior = 'auto';
            pinnedScrollY = window.scrollY; // Capture current scroll position
            scrollLocked = true;
            // Use capturing phase to intercept scroll early
            window.addEventListener('scroll', handleScroll, { capture: true, passive: true });
        }
    }

    function unlockScroll() {
        if (scrollLocked) {
            document.body.style.overflow = '';
            // Re-enable smooth scroll after unlock
            document.documentElement.style.scrollBehavior = '';
            document.body.style.scrollBehavior = '';
            scrollLocked = false;
            aligned = false;
            window.removeEventListener('scroll', handleScroll, { capture: true });
        }
    }

    // Handle wheel events
    function handleWheel(e) {
        if (!isInViewport()) {
            unlockScroll();
            return;
        }

        // On first interaction, lock to current position (no snap animation)
        if (!aligned) {
            lockScroll();
            aligned = true;
        }

        const atStart = swiper.isBeginning;
        const atEnd = swiper.isEnd;
        const deltaDown = e.deltaY > 0;
        const deltaUp = e.deltaY < 0;

        // While inside slider, lock page scroll by default
        lockScroll();

        // Move slides when not at boundary
        if ((deltaDown && !atEnd) || (deltaUp && !atStart)) {
            e.preventDefault();
            releaseCounter = 0; // reset boundary release counter
            scrollCounter++;

            if (scrollCounter >= scrollsNeeded) {
                scrollCounter = 0;
                if (deltaDown) {
                    swiper.slideNext();
                } else if (deltaUp) {
                    swiper.slidePrev();
                }
            }
            return;
        }

        // At boundary: require extra scrolls before releasing page scroll
        if ((deltaDown && atEnd) || (deltaUp && atStart)) {
            if (releaseCounter < releaseNeeded) {
                e.preventDefault();
                releaseCounter++;
                return;
            }
            // release after required scrolls
            unlockScroll();
            scrollCounter = 0;
            releaseCounter = 0;
            return;
        }

        // Fallback: unlock
        unlockScroll();
    }

    // Add wheel listener
    sliderContainer.addEventListener('wheel', handleWheel, { passive: false });

    // Cleanup on destroy
    swiper.on('destroy', () => {
        sliderContainer.removeEventListener('wheel', handleWheel);
        window.removeEventListener('scroll', handleScroll, { capture: true });
        unlockScroll();
    });
}
